/* MIT License

Copyright (c) 2025 Brad Schick

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE. */
import type { Routes } from '@angular/router';
import { CoreComponent } from './core/core.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { showRecoveryGuard } from './showrecovery/showrecovery.guard';
import { cmdlineGuard } from './cmdline/cmdline.guard';
import { coreGuard } from './core/core.guard';
import { welcomeGuard } from './welcome/welcome.guard';
import { guardedImport } from './reloader';

export const routes: Routes = [
   {
      path: 'welcome',
      component: WelcomeComponent,
      canActivate: [welcomeGuard],
   },
   {
      path: 'newuser',
      loadComponent: () => guardedImport(() => import('./newuser/newuser.component').then((m) => m.NewUserComponent)),
   },
   {
      path: 'showrecovery',
      loadComponent: () =>
         guardedImport(() => import('./showrecovery/showrecovery.component').then((m) => m.ShowRecoveryComponent)),
      canActivate: [showRecoveryGuard],
   },
   {
      path: 'regenrecovery',
      loadComponent: () =>
         guardedImport(() => import('./regenrecovery/regenrecovery.component').then((m) => m.RegenrecoveryComponent)),
      canActivate: [showRecoveryGuard],
   },
   {
      path: 'checkrecovery',
      loadComponent: () =>
         guardedImport(() => import('./checkrecovery/checkrecovery.component').then((m) => m.CheckRecoveryComponent)),
      canActivate: [showRecoveryGuard],
   },
   {
      path: 'recovery',
      loadComponent: () =>
         guardedImport(() => import('./recovery/recovery.component').then((m) => m.RecoveryComponent)),
   },
   {
      path: 'recovery3',
      loadComponent: () =>
         guardedImport(() => import('./recovery3/recovery3.component').then((m) => m.Recovery3Component)),
   },
   {
      path: 'recovery2',
      redirectTo: 'recovery3',
      pathMatch: 'full',
   },
   {
      path: 'cmdline',
      loadComponent: () => guardedImport(() => import('./cmdline/cmdline.component').then((m) => m.CmdLineComponent)),
      canActivate: [cmdlineGuard],
   },
   {
      path: 'help',
      loadChildren: () => guardedImport(() => import('./help/help.routes').then((m) => m.helpRoutes)),
   },
   {
      path: '',
      component: CoreComponent,
      canActivate: [coreGuard],
   },
   {
      path: '**',
      redirectTo: '',
      pathMatch: 'full',
   },
];
